<app-card-relatorio-laudo [titulo]="template.label" [status]="template.status">
    <div class="d-flex">
        <div *ngIf="imgMarcaVeiculo" class="p-2"><img class="img-marca-veiculo" [src]="imgMarcaVeiculo" alt=""></div>
        <app-lista-titulo-desc [ngClass]="['d-block', 'w-100']" [elements]="template.elements"></app-lista-titulo-desc>
    </div>
    <app-lista-img [elements]="template.elements" [cols]="6"></app-lista-img>
</app-card-relatorio-laudo>